import { Navigate, Outlet } from 'react-router-dom';
import LocalStorageType from '../../constants/LocalStorageType';

const ProtectedRoute = ({ superAdminOnly = false }) => {
    const user = JSON.parse(localStorage.getItem(LocalStorageType.USER_DETAILS)); 
    
    if (superAdminOnly) {
        return user?.superAdmin ? <Outlet /> : <Navigate to="/access-denied" replace />;
    }

    return user?.admin || user?.superAdmin ? <Outlet /> : <Navigate to="/access-denied" replace />;
  };

export default ProtectedRoute;